export default "__VITE_ASSET__BumuXhS1__"